export default {"src":"/_next/static/media/warning-fill.8d7ffe0f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};